export const SanityConfig = {
	basePath:         '/studio',
	projectid:        process.env.NEXT_PUBLIC_WASTIC_SANITY_PROJECT_ID ?? '',
	dataset:          process.env.NEXT_PUBLIC_WASTIC_SANITY_DATASET ?? '',
	title:            process.env.NEXT_PUBLIC_WASTIC_SANITY_PROJECT_TITLE ?? 'Sanity Studio',
	apiVersion:       process.env.NEXT_PUBLIC_WASTIC_SANITY_API_VERSION ?? '2023-10-01',
	revalidateSecret: process.env.WASTIC_SANITY_REVALIDATE_SECRET,
	readToken:        process.env.NEXT_PUBLIC_WASTIC_SANITY_API_READ_TOKEN,
	disableDraft:     '/api/sanity/disable-draft',
};
